__turbopack_context__.v({
  "actions": "_56fjHa_actions",
  "content": "_56fjHa_content",
  "imageBox": "_56fjHa_imageBox",
  "root": "_56fjHa_root",
  "subtitle": "_56fjHa_subtitle",
  "text": "_56fjHa_text",
  "title": "_56fjHa_title",
});
